import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import { Link,useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  //console.log(children)
  let history=useHistory();
  const logout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("balance");
    window.location.reload();
    history.push('/login')

  };

  const login = () => {
    history.push("/login");
  };
  const register = () => {
    history.push("/register");
  };
  const explore = () => {
    history.push("/");
  };
  const localstr = localStorage.getItem("username");
  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {children}
   

     

      {hasHiddenAuthButtons && (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={explore}
        >
          
            Back to explore
          
        </Button>
      )}

      {!hasHiddenAuthButtons && localstr && (
        <>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={2}
          >
            <Avatar alt={localStorage.getItem("username")} src="avatar.png" />
            <div className="header-info">
              {localStorage.getItem("username")}
            </div>
            <Button variant="text" onClick={logout}>
              Logout
            </Button>
          </Stack>
        </>
      )}

      {!hasHiddenAuthButtons && !localstr && (
        <>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={2}
          >
            <Button variant="text" onClick={login}>
              
                Login
             
            </Button>
            <Button variant="contained" onClick={register}>

                Register
      
            </Button>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default Header;
